import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-app-formed-company-pie-chart',
    templateUrl: './app-formed-company-pie-chart.component.html',
    styleUrls: ['./app-formed-company-pie-chart.component.scss']
})
export class AppFormedCompanyPieChartComponent implements OnInit {
    private _formedCompanyData: any;
    get formedCompanyData() {
        return this._formedCompanyData;
    }

    @Input() set formedCompanyData(val: any) {
        this._formedCompanyData = val;
        if (val) {
            this.formedCompanyChart = {
                chart: {
                    toolbar: {
                        show: true
                    },
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    height: '100%',
                    type: 'pie',
                    sparkline: {
                        enabled: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '13px',
                        // fontWeight: 'bold',
                    },
                },
                colors: ['#3182CE', '#63B3ED'],
                labels: this._formedCompanyData.labels,
                plotOptions: {
                    pie: {
                        customScale: 0.9,
                        expandOnClick: false,
                        donut: {
                            size: '70%'
                        },
                        dataLabels:{
                            offset: -20,  style: {
                textShadow: false
              }
                        }
                    }
                },
                series: this._formedCompanyData.series.map(p => p.percentageValue),
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        }
                    },
                    active: {
                        filter: {
                            type: 'none'
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: false,
                    theme: 'dark',
                    custom: ({
                                 seriesIndex,
                                 w
                             }): string => `<div class="flex items-center h-8 min-h-8 max-h-8 px-3">
                                                    <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
                                                    <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
                                                    <div class="ml-2 text-md font-bold leading-none">${w.config.series[seriesIndex]}%</div>
                                                </div>`
                }
            };
        }
    }

    formedCompanyChart: any;

    constructor() {
    }

    ngOnInit(): void {
    }

}
